module.exports = __webpack_public_path__ + "static/17-782378a8bb8da5ac8bcf56609a557e63.jpg";